import React from 'react';
import b_ from 'b_';
import I18N from 'assets/i18n/brandlift-project';

import {useOrgDeleteRole} from 'client/common/hooks/orgs/roles';
import {useModal} from 'client/common/hooks/modal';
import {Button, Icon} from 'client/common/components/lego';

import {RoleEdit, RolePermission} from './role-edit';

import './org-access.css';

const b = b_.with('org-access');

const i18n = I18N.orgAccess;

export function RoleRow({
    orgId,
    roleId,
    name,
    permissions,
    userCount,
    disabled
}: {
    orgId: number;
    roleId: number;
    name: string;
    permissions: RolePermission[];
    userCount: number;
    disabled: boolean;
}) {
    const deleteOrgRole = useOrgDeleteRole(orgId, roleId);
    const [showModal] = useModal();

    const handleEditRole = () => {
        showModal(
            <RoleEdit
                name={name}
                permissions={permissions}
                orgId={orgId}
                roleId={roleId}
                // disabled={disabled}
            />,
            {
                withCross: true
            }
        );
    };

    const handleRoleDelete = async () => {
        await deleteOrgRole();
    };

    return (
        <>
            <div className={b('role-name')}>
                <span className={b('role-name-text')}>{name}</span>
            </div>
            <div className={b('role-users')}>
                <span className={b('role-users-text')}>{userCount}</span>
            </div>
            <div className={b('role-permissions')}>
                {permissions.map(perm => {
                    return (
                        <span key={perm} className={b('permissions-label')}>
                            {i18n.permissionsMap[perm]}
                        </span>
                    );
                })}
            </div>

            <div className={b('role-btns')}>
                <div className={b('role-btns-container')}>
                    <Button
                        view='dl-light'
                        size='m'
                        onClick={handleEditRole}
                        iconLeft={(cls: string) => <Icon className={cls} type='gear' size='m' />}
                    >
                        {i18n.roleSettingsBtn}
                    </Button>
                    {!disabled && (
                        <Button
                            view='dl-light'
                            size='m'
                            disabled={disabled}
                            onClick={handleRoleDelete}
                            iconLeft={(cls: string) => (
                                <Icon className={cls} type='trash' size='m' />
                            )}
                        >
                            {i18n.removeRoleBtn}
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
}
